import { MenuItemModel } from './menu-item.model';

export class ExternalLinkItemModel extends MenuItemModel {
  constructor(
    public label: string,
    public icon?: string,
    public disabled?: boolean,
    public visible?: boolean,
    public link?: string
  ) {
    super(label, null, null, null, icon, null, disabled, visible, link, true);
  }
}
